import { forEach } from 'lodash';

export const clearModal = $transitions => {
  'ngInject';

  $transitions.onStart('*', () => {
    const items = document.getElementsByClassName('modal-open');

    forEach(items, item => {
      item.classList.remove('modal-open');
    });
  });
};



// WEBPACK FOOTER //
// ./src/utils/clearModal.js